import moment from 'moment'

export const START_DATE_SHORT_NAME = 'startDate'
export const startDateDefault = null

export const END_DATE_SHORT_NAME = 'endDate'
export const endDateDefault = null

export const START_DATE_FILTER_CONFIG = {
  short_name: START_DATE_SHORT_NAME,
  default_values: startDateDefault,
  is_default: (value) => testStartDateDefault(value), //right before clean up
  format_to_api: (value) => formatStartDateForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: (value) => formatDateFromURL(value), //
}

export const END_DATE_FILTER_CONFIG = {
  short_name: END_DATE_SHORT_NAME,
  default_values: endDateDefault,
  is_default: (value) => testEndDateDefault(value), //right before clean up
  format_to_api: (value) => formatEndDateForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: (value) => formatDateFromURL(value), //
}

export const formatDateFromURL = (value) => {
  let cleanValue = null
  if (isSearchDateValid(value)) {
    cleanValue = moment(value)
      .format('YYYY-MM-DD')
      .toString()
  }
  return cleanValue
}

export const testStartDateDefault = (value) => {
  if (value === startDateDefault) {
    return true
  } else {
    return false
  }
}

export const testEndDateDefault = (value) => {
  if (value === endDateDefault) {
    return true
  } else {
    return false
  }
}

export const isSearchDateValid = (value) => {
  //alert(value)
  if (moment(value).isValid() && moment(value).isSameOrAfter(moment(), 'day')) {
    return true
  } else {
    return false
  }
}

export const isStartEndValid = (startDate, endDate) => {
  if (isSearchDateValid(startDate) && isSearchDateValid(endDate)) {
    return true
  } else {
    return false
  }
}

//api

export const formatStartDateForAPI = (value) => {
  if (value) {
    return { start_date: value }
  }
}

export const formatEndDateForAPI = (value) => {
  if (value) {
    return { end_date: value }
  }
}
